import { Stack, Chip, useTheme } from "@mui/material";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

export const FilePreview = ({ files, onDeleteFile }: { files: File[]; onDeleteFile?: (file: File) => void }) => {
    const theme: SenecFPPTheme = useTheme();
    return (
        <Stack direction="row" flexWrap="wrap" data-testid="file-upload-file-preview">
            {files.map((file) => (
                <Chip
                    sx={{
                        width: "auto",
                        m: "0.5rem 0.5rem 0.5rem 0",
                        backgroundColor: theme.palette.neutralGray30.main,
                    }}
                    key={`${file.name}_${file.type}`}
                    label={file.name}
                    onDelete={onDeleteFile ? () => onDeleteFile(file) : undefined}
                />
            ))}
        </Stack>
    );
};
